// API configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://oztbackend.onrender.com';

// InPost Geowidget public token
// Replace 'YOUR_PUBLIC_INPOST_GEOWIDGET_TOKEN' with the actual token from your InPost account.
export const INPOST_GEOWIDGET_TOKEN = 'YOUR_PUBLIC_INPOST_GEOWIDGET_TOKEN';
